//@ts-ignore
import convert from 'color-convert';
import {createFilter} from './basic';



function _hsvValue(r,g,b){
  const value = Math.ceil(255 * convert.rgb.hsv(r, g, b)[2] / 100);
  return [value,value,value];
}
function _hsvSturation(r, g,b){
  const value = Math.ceil(255 * convert.rgb.hsv(r, g, b)[1] / 100);
  return [value,value,value];
}
let hsvValue = createFilter(_hsvValue);
let hsvSaturation = createFilter(_hsvSturation);
export default  {hsvValue,hsvSaturation};
